module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Pomodoro-1.f366daf6.jpg";